// this file is created by src/build/createEnv.js
export const COMMIT_REF = "560308af5fcbf36bd0f062f146349a7e8de5643f"
export const BRANCH = "main"